<template>
    <div class="flex h-full w-full flex-col gap-3">
        <DxTabs :selected-index="currentTabIndex" :visible="!balIsSK" @itemClick="onTabItemClick">
            <DxItem :id="tabsMeta.gridIndex" :text="tabsMeta.gridText" />
            <DxItem :id="tabsMeta.regGridIndex" :text="tabsMeta.regGridText" />
        </DxTabs>
        <ai-dictionary-grid-ro
            v-show="currentTabIndex === tabsMeta.gridIndex"
            ref="gridRef"
            :args="gridRoArgs"
            :meta="gridRoMeta"
            @dictionarySelectionChanged="selectionChanged"
        />
        <ai-dictionary-virtual-grid
            v-show="currentTabIndex === 1"
            ref="regGridRef"
            :current-value="currentValue"
            :meta="virtualGridMeta"
            @dictionarySelectionChanged="selectionChanged"
        />
    </div>
</template>
<script setup>
import { DxTabs } from 'devextreme-vue/tabs';
import { DxItem } from 'devextreme-vue/data-grid';
import AiDictionaryGridRo from '@/components/dictionary-components/ai-dictionary-grid-ro.vue';
import AiDictionaryVirtualGrid from '@/components/dictionary-components/ai-dictionary-virtual-grid.vue';
import { computed, onMounted, ref } from 'vue';

const props = defineProps({
    rowClickCallBack: {
        type: Function,
        default: () => {},
    },
    currentValue: {
        type: String,
    },
    args: {
        type: Object,
        default: () => {},
    },
});
const emit = defineEmits(['selectionChanged']);
const tabsMeta = {
    gridIndex: 0,
    gridText: 'РЭС',
    regGridIndex: 1,
    regGridText: 'Организации',
};
const gridRoMeta = {
    keyExpr: 'kodp',
    columns: [
        { dataField: 'sname', caption: 'Кратк. наимен.' },
        { dataField: 'name', caption: 'Наименование' },
        { dataField: 'parentname', caption: 'Филиал МРСК \\ ФСК \\ ТСК' },
    ],
    api: { select: 'e-grid./expl/data/get' },
};
const gridRoArgs = computed(() => {
    const baseArgs = {
        select_args: { schema: 'e_grid', table: 'hv_org_res' },
    };
    return props.args['bal_id'] && balIsSK.value
        ? {
              ...baseArgs,
              select_args: {
                  ...baseArgs.select_args,
                  filter_field: 'kod_parent',
                  filter_operator: '=',
                  filter_value: props.args['bal_id'],
              },
          }
        : baseArgs;
});

const virtualGridMeta = {
    columns: [
        { field: 'kodp', text: 'kodp', visible: false },
        { field: 'enscope_name', text: 'enscope_name', visible: false },
        { field: 'sname', text: 'Код', width: 100 },
        { field: 'name', text: 'Наименование', width: 250 },
        { field: 'kod_separator', text: 'kod_separator', visible: false },
        { field: 'kod_ecls', text: 'kod_ecls', visible: false },
        { field: 'kod_parent', text: 'kod_parent', visible: false },
        { field: 'inn', text: 'ИНН', width: 100 },
        { field: 'kpp', text: 'КПП', width: 100 },
        { field: 'addr', text: 'Адрес юридический' },
        { field: 'pr_active', text: 'pr_active', data_type: 'boolean', visible: false },
    ],
    loadUrl: 'e-grid./bal/data/get',
    keyExpr: 'kodp',
    autoLoadData: false,
    toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
};

const gridRef = ref(null);

const regGridRef = ref(null);

const currentTabIndex = ref(0);
const gridFocusedRowKey = ref(null);
const balIsSK = computed(() => props.args['bkod_ecls'] === 2);
const onTabItemClick = async event => {
    if (event.itemIndex === 1) {
        if (regGridRef.value) {
            await regGridRef.value.gridInstance.loadData();
        }
    }
    currentTabIndex.value = event.itemIndex;
};
const selectionChanged = async event => {
    props.rowClickCallBack({ row: event.data ? event.data : event, keyExpr: 'kodp' });
    emit('selectionChanged', event.data ? event.data : event);
};
const setGridFocusedRowKey = rowKey => {
    gridFocusedRowKey.value = rowKey;
};

const loadData = async () => {
    if (gridRef.value) {
        await gridRef.value.gridRoRef.refreshData();
    }
    if (regGridRef.value) {
        await regGridRef.value.gridInstance.loadData();
    }
};
onMounted(async () => {
    await loadData();
});
defineExpose({
    loadData,
    setGridFocusedRowKey,
});
</script>
